// The home page (`/`): the landing page, or the waitlist sign-up while the waitlist is on for this
// visitor. Both render as React Server Components in the `rsc` environment, so the browser gets only
// their client components (and only those of the variant shown), not the page's static sections.
import { createServerFn } from "@tanstack/react-start";
import { renderServerComponent } from "@tanstack/react-start/rsc";
import LandingPage from "src/components/landing/LandingPage/LandingPage";
import WaitlistPage from "src/components/landing/WaitlistPage/WaitlistPage";
import { isMaintenanceBypassed, isSignedInForWaitlist, isWaitlistBypassed } from "src/lib/Bypass";
import { LANDING_JSON_LD, serializeJsonLd } from "src/lib/LandingJsonLd";
import { withHydrationMarker } from "src/lib/ServerContent";
import { BLOG_POSTS } from "src/server/blog/BlogIndex";
import { renderCachedServerComponent } from "src/server/FlightCache";

/** The waitlist replaces the landing page for signed-out visitors without a bypass cookie. */
const shouldRenderWaitlist = async () => {
  if (import.meta.env.PUBLIC_WAITLIST !== "true") return false;
  return (
    !isSignedInForWaitlist() && !(await isMaintenanceBypassed()) && !(await isWaitlistBypassed())
  );
};

export const getHomePage = createServerFn({ method: "GET" }).handler(async () => {
  if (await shouldRenderWaitlist()) {
    return {
      waitlist: true,
      content: await renderServerComponent(
        withHydrationMarker(
          <>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: serializeJsonLd(LANDING_JSON_LD) }}
            />
            <WaitlistPage latestPost={BLOG_POSTS[0]} />
          </>,
        ),
      ),
    };
  }
  return {
    waitlist: false,
    content: await renderCachedServerComponent("home:landing", () =>
      renderServerComponent(
        withHydrationMarker(
          <>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: serializeJsonLd(LANDING_JSON_LD) }}
            />
            <LandingPage latestPost={BLOG_POSTS[0]} />
          </>,
        ),
      ),
    ),
  };
});
